var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#a6fa9f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)",
    fill: "#222"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.08 41.169V23.671l.178-1.097c.911-4.062 3.37-6.666 7.379-7.78.521-.146 1.07-.198 1.606-.293h17.49c.112.022.227.049.339.061.98.107 1.937.324 2.824.744 3.848 1.821 5.922 4.869 5.98 9.131l.015 15.957c-.002 2.063-.558 3.972-1.755 5.651-2.03 2.848-4.825 4.276-8.32 4.286a2727.98 2727.98 0 0 1-15.669-.005c-.673-.003-1.36-.037-2.015-.183-4.055-.895-6.65-3.365-7.764-7.368-.139-.522-.192-1.07-.287-1.607zm32.643-8.745v-7.768c0-.819-.083-1.629-.358-2.409-1.011-2.85-3.465-4.567-6.563-4.569-5.21-.007-10.42-.017-15.633.015-.78.005-1.596.112-2.332.358-2.863.963-4.576 3.445-4.581 6.541v15.64c0 .807.09 1.604.365 2.372 1.011 2.823 3.441 4.542 6.502 4.552H39.86c2.349-.005 4.243-.946 5.629-2.852.88-1.212 1.236-2.592 1.236-4.077l-.002-7.804zm-5.503 0c-.005 5.076-4.182 9.248-9.243 9.231-5.084-.017-9.246-4.198-9.219-9.257.027-5.079 4.162-9.209 9.226-9.214s9.241 4.172 9.236 9.24zm-9.238 6.044c3.329.01 6.044-2.701 6.053-6.042.01-3.33-2.7-6.047-6.039-6.056-3.329-.01-6.044 2.701-6.053 6.042-.01 3.33 2.7 6.047 6.039 6.056zm9.677-17.966c1.282.037 2.318 1.107 2.279 2.353a2.34 2.34 0 0 1-2.417 2.287c-1.25-.041-2.279-1.124-2.245-2.355.037-1.297 1.104-2.321 2.383-2.285z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(14.08 14.501)",
    d: "M0 0h35.84v35.84H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramRound);
export default __webpack_public_path__ + "static/media/instagram_round.6e16747b3e61c4b3bea08c4b497986f1.svg";
export { ForwardRef as ReactComponent };